import $ from 'jquery';
import { showButtonLoader, hideButtonLoader, } from '../../../../../../../src/AppBundle/Resources/public/javascripts/utils/button-loader';
export default class SimpleAjaxForm {
    static init() {
        $(document).on('submit', '.js__simple-ajax-form', event => {
            event.preventDefault();
            const $form = $(event.currentTarget);
            const $submitButton = $form.find('[type="submit"]');
            showButtonLoader($submitButton);
            $.ajax({
                method: $form.attr('method'),
                url: $form.attr('action'),
                data: $form.serialize(),
            })
                .done(data => {
                $($form.data('content-load-selector')).html(data);
            })
                .fail(xhr => {
                $($form.data('content-load-selector')).html(xhr.responseText);
            })
                .always(() => {
                hideButtonLoader($submitButton);
            });
        });
    }
}
